import { addStyles } from '../../components/theme';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { CSS, Style } from './dashboard.table.style';

addStyles(Style);

export const Table = {
	view(title: string | MithrilVNode, header: MithrilVNode[] | string[], rows: MithrilVNode[][]): MithrilVNode {
		const headerChildren: MithrilVNode[] = [];
		let i = 0;
		for (const colHeader of header) {
			headerChildren.push(m('th', { className: `${CSS.MDL.cell} ${rows[0][i].attrs.className}` }, colHeader));
			i++;
		}

		const bodyChildren: MithrilVNode[] = [];
		for (const row of rows) {
			const rowChildren: MithrilVNode[] = [];
			for (const col of row) {
				rowChildren.push(m('td', { className: `${CSS.cell} ${CSS.MDL.cell} ${col.attrs.className}` }, col));
			}

			bodyChildren.push(m('tr', { className: CSS.row }, rowChildren));
		}

		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.title }, title),
			m('table', { className: `${CSS.body} ${CSS.MDL.table}` }, [
				m('thead', { className: CSS.header }, headerChildren),
				m('tbody', bodyChildren),
			]),
		]);
	},
};
